import http from '../../../api/httpClient';

export interface CtoNote {
    cn_number: string;
    content: string;
    created_by: string;
    created_at: string;
}

export interface CtoNoteListResponse {
    cn_number: string;
    notes: CtoNote[];
}

export interface CtoNoteCreatePayload extends Record<string, unknown> {
    content: string;
}

export const getCtoNotes = async (cnNumber: string): Promise<CtoNoteListResponse> => {
    try {
        return http.get<CtoNoteListResponse>(`/api/v1/cto/notes/${encodeURIComponent(cnNumber)}`);
    } catch (error) {
        console.error("Error fetching CTO notes:", error);
        throw error;
    }
};


export const createCtoNote = async (cnNumber: string, payload: CtoNoteCreatePayload): Promise<CtoNote> => {
    try {
        return http.post<CtoNote>(`/api/v1/cto/notes/${encodeURIComponent(cnNumber)}/add`, payload);
    } catch (error) {
        console.error("Error creating CTO note:", error);
        throw error;
    }
};
